import { apiClient } from './apiService'

export const templateService = {
  async getTemplates(params = {}) {
    const response = await apiClient.get('/templates/', { params })
    return response.data
  },
  
  async createTemplate(template) {
    const response = await apiClient.post('/templates/', template)
    return response.data
  },
  
  async getTemplate(id) {
    const response = await apiClient.get(`/templates/${id}`)
    return response.data
  },
  
  async updateTemplate(id, updates) {
    const response = await apiClient.put(`/templates/${id}`, updates)
    return response.data
  },
  
  async deleteTemplate(id) {
    const response = await apiClient.delete(`/templates/${id}`)
    return response.data
  },
  
  async useTemplate(id) {
    const response = await apiClient.post(`/templates/${id}/use`)
    return response.data
  },

  /**
   * Generate extraction schema from LLM instruction using OpenAI GPT only.
   * Requires OPENAI_API_KEY on the backend.
   */
  async generateSchema(llmInstruction) {
    const response = await apiClient.post('/templates/generate-schema', {
      llm_instruction: llmInstruction
    })
    return response.data
  }
}

export default templateService

